import { createImmerReducer } from "utils/ReducerUtils";
import type { ReduxAction } from "ee/constants/ReduxActionConstants";
import {
  ReduxActionTypes,
  ReduxActionErrorTypes,
} from "ee/constants/ReduxActionConstants";

export interface DrawDBReduxState {
  list: any[];
  groupApps: any[];
  loadingStates: {
    isFetchingDrawDBGroups: boolean;
    isFetchingDrawDBApps: boolean;
    isFetchingDrawDBApp: boolean;
    isCreatingDrawDB: boolean;
    isImportingDrawDBApp: boolean;
  };
  drawDBApp: any;
  currentGroup: any;
  permissionGroups: any[];
  groupUsers: any[];
}

export const initialState: DrawDBReduxState = {
  loadingStates: {
    isFetchingDrawDBGroups: false,
    isFetchingDrawDBApps: false,
    isFetchingDrawDBApp: false,
    isCreatingDrawDB: false,
    isImportingDrawDBApp: false,
  },
  currentGroup: {},
  groupApps: [],
  list: [],
  drawDBApp: {},
  permissionGroups: [],
  groupUsers: [],
};

export const handlers = {
  [ReduxActionTypes.FETCH_DRAW_DB_GROUPS_INIT]: (
    drawdbState: DrawDBReduxState,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBGroups = true;
  },
  [ReduxActionTypes.FETCH_DRAW_DB_GROUPS_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any[]>,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBGroups = false;
    drawdbState.list = action.payload;
  },

  [ReduxActionTypes.FETCH_DRAW_DB_APPS_INIT]: (
    drawdbState: DrawDBReduxState,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBApps = true;
  },
  [ReduxActionTypes.FETCH_DRAW_DB_APPS_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any[]>,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBApps = false;
    drawdbState.groupApps = action.payload;
  },

  [ReduxActionTypes.CREATE_DRAW_DB_INIT]: (
    drawdbState: DrawDBReduxState,
  ) => {
    drawdbState.loadingStates.isCreatingDrawDB = true;
  },

  [ReduxActionTypes.CREATE_DRAW_DB_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.loadingStates.isCreatingDrawDB = false;
    drawdbState.drawDBApp = action.payload;
  },

  [ReduxActionTypes.FETCH_DRAW_DB_APP_INIT]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBApp = true;
  },
  [ReduxActionTypes.CREATE_DRAW_DB_GROUP_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.currentGroup = action.payload;
  },
  [ReduxActionTypes.FETCH_DRAW_DB_APP_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.loadingStates.isFetchingDrawDBApp = false;
    drawdbState.drawDBApp = action.payload;
  },
  [ReduxActionTypes.EDIT_DRAW_DB_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
    ) => {
    drawdbState.drawDBApp = action.payload;
  },
  [ReduxActionTypes.IMPORT_DRAW_DB_APP_INIT]: (
    drawdbState: DrawDBReduxState,
  ) => {
    drawdbState.loadingStates.isImportingDrawDBApp = true;
  },
  [ReduxActionTypes.IMPORT_DRAW_DB_APP_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.drawDBApp = action.payload;
    drawdbState.loadingStates.isImportingDrawDBApp = false;
  },
  [ReduxActionErrorTypes.IMPORT_DRAW_DB_APP_ERROR]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.loadingStates.isImportingDrawDBApp = false;
  },
  [ReduxActionTypes.FETCH_DRAW_DB_PERMISSION_GROUPS_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.permissionGroups = action.payload;
  },

  [ReduxActionTypes.FETCH_DRAW_DB_GROUP_USERS_SUCCESS]: (
    drawdbState: DrawDBReduxState,
    action: ReduxAction<any>,
  ) => {
    drawdbState.groupUsers = action.payload;
  },
};

const drawDBReducer = createImmerReducer(initialState, handlers);

export default drawDBReducer;
